import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Icon, { GLYPHS } from '../icon';

const Avatar = ({ who, imageUrl, editable, size, iconClassName }) => {
  if (imageUrl) {
    return <img className="c-avatar-upload__img" src={imageUrl} alt="" />;
  }

  return (
    <div className="u-inline-block">
      <div className={classnames('c-add-avatar u-inline-block u-mr-', `c-add-avatar--${size}`, { 'is-disabled': !editable })}>
        <Icon glyph={GLYPHS.addPhoto} className={iconClassName} size={size} />
      </div>
      <div display-if={editable} className="c-heading c-heading--small u-inline-block">Please add {who} photo</div>
    </div>
  );
};

Avatar.propTypes = {
  who: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  editable: PropTypes.bool,
  size: PropTypes.string,
  iconClassName: PropTypes.string,
};

Avatar.defaultProps = {
  color: '',
  imageUrl: '',
  editable: true,
  size: 'medium',
  iconClassName: '',
};

export default Avatar;
